import React from 'react'
import {AiFillHome} from 'react-icons/ai'
import {FaBrain} from 'react-icons/fa'
import {IoMdCodeWorking} from 'react-icons/io'
import {MdPermContactCalendar} from 'react-icons/md'
import {SiAboutdotme} from 'react-icons/si'
import { Link } from 'react-router-dom'
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';

import './style.css'
export default function Navigation() {
  const BootstrapTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} arrow classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.arrow}`]: {
      color: theme.palette.common.black,
    },
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: theme.palette.common.black,
    },
  }));

  return (
    <div className='navigation'>
        <ul>
          <BootstrapTooltip title="Home" arrow>
            <li style={{'--i':'#cd9765','--o':'#db179d'}}><Link to='/'><AiFillHome/></Link></li>
          </BootstrapTooltip>
          <BootstrapTooltip  title="Skill" arrow>
            <li style={{'--i':'#56ab2f','--o':'#a8e063'}}><Link to='/skills'><FaBrain/></Link></li>
          </BootstrapTooltip>
          <BootstrapTooltip title="Projects" arrow>
            <li style={{'--i':'#56ab2f','--o':'#a8e063'}}><Link to='/projects'><IoMdCodeWorking/></Link></li> 
          </BootstrapTooltip>
          <BootstrapTooltip title="About me" arrow>
            <li style={{'--i':'#56ab2f','--o':'#a8e063'}}><Link to='/about'><SiAboutdotme/></Link></li>
          </BootstrapTooltip>
          <BootstrapTooltip title="Contact me" arrow>
            <li style={{'--i':'#56ab2f','--o':'#a8e063'}}><Link to='/contact-me'><MdPermContactCalendar/></Link></li>
          </BootstrapTooltip>
        </ul>
    </div>
  )
}
